// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LuEt","label":"styles_label__3BwIN"};